import LoadsList from "./LoadsList";

export default LoadsList;